import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/vinculo-departamento-medico`;
export const create = async (obj) => {
  return await axios.post(`${httpUrl}/create`, obj).then((response) => response);
};

export const getLista = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
